module.exports = __webpack_public_path__ + "img/logo7.6ae5626e.jpg";